import React, {Component} from 'react';

import DefaultLayout from '../Layout/DefaultLayout.jsx';
import {ImageHeader, ImageHeaderTitle, ImageHeaderBrief} from '../../components/ImageHeader/ImageHeader.jsx';
import TimelineSource from '../../components/Timeline/Timeline.jsx';
// import TimelineElement from '../../components/Timeline/TimelineElement.jsx';

import './Press.scss';

export default class Press extends Component {
  render() {
    const title = "Twineeds | Revue de Presse et Actualités";
    const description = "Consultez les dernières actualités et retombées presse de Twineeds. Médias, interviews et publications sur notre plateforme.";

    return (
      <DefaultLayout showSidebarMenu={false} className="press" helmet={{title, description}}>
        <ImageHeader>
          <ImageHeaderTitle>
            <h1>Ils parlent de nous</h1>
          </ImageHeaderTitle>
          <ImageHeaderBrief>
            Retrouvez toutes les actualités de Twineeds
          </ImageHeaderBrief>
        </ImageHeader>
        <div className="container">
          <TimelineSource className="mt-5">
          </TimelineSource>
        </div>
      </DefaultLayout>
    );
  }
}